import {Endpoints} from "../Endpoints";
import Backend from "../../Backend";

export default class Brand
{
	constructor(token)
	{
		this.backend = new Backend(token);
	}

	all(callback)
	{
		this.backend.callBackend(`${Endpoints.brand.private}/catalog/all`, callback);
	}

	purchaseAll(callback){
		this.backend.callBackend(`${Endpoints.brand.private}/active`, callback);
	}

	allAvaiable(callback){
		this.backend.callBackend(`${Endpoints.brand.private}/catalog/allAvailableBrands`, callback);
	}
   status(data,callback){
	this.backend.callBackend(`${Endpoints.brand.status}/giftcard/status`, callback ,"PUT",data)
   }

   statusAll(data,callback){
	this.backend.callBackend(`${Endpoints.brand.status}/giftCard/toggleAll`, callback ,"PUT",data)
   }
	region(callback){
		this.backend.callBackend(`${Endpoints.brand.region}/all`,callback);
	}

	brand(id, callback)
	{
		this.backend.callBackend(`${Endpoints.brand.private}/catalog/${id}`, callback);
	}

	add(brandInfo, logo, callback)
	{
		const data = new FormData();
		data.append("brandInfo", Backend.wrapJSONBody(brandInfo));

		if (logo)
			data.append("logo", logo);

		this.backend.callBackend(`${Endpoints.brand.private}`, callback, "POST", data, false);
	}

	update(id, brandInfo, logo, callback)
	{
		const data = new FormData();
		data.append("brandInfo", Backend.wrapJSONBody(brandInfo));

		if (logo)
			data.append("logo", logo);

		this.backend.callBackend(`${Endpoints.brand.private}/${id}`, callback, "PUT", data, false);
	}
	
	remove(id, callback)
	{
		this.backend.callBackend(`${Endpoints.brand.private}/${id}`, callback, "DELETE");
	}

	logo(brand, forceReload = false, suffix = null)
	{
		return `${this.backend.url}${Endpoints.brand.public}/logo/${encodeURIComponent(brand)}${forceReload ? "?no-cache=" + (suffix ?? Date.now()) : ''}`;
	}

	logoByUuid(uuid, forceReload = false, suffix = null)
	{
		return `${this.backend.url}${Endpoints.brand.public}/logo/uuid/${uuid}${forceReload ? "?no-cache=" + (suffix ?? Date.now()) : ''}`;
	}

	bestSupplier(id, callback)
	{
		this.backend.callBackend(`${Endpoints.brand.best}/${id}`, callback);
	}
	
	brandBySupplier(id, callback) {
        this.backend.callBackend(`${Endpoints.brand.all}/${id}`, callback)
    }
	brandByInvertory(id,callback){
		this.backend.callBackend(`${Endpoints.brand.inventory}/purchaser/${id}/brands`, callback)
	}

	pendingPurchaseOrders(id, callback)
	{
		this.backend.callBackend(`private/backoffice/purchase-order/brand/${id}/pending`, callback);
	}
	uploadBrand(data, callback) {
		this.backend.callBackend(`${Endpoints.brand.private}/catalog/upload`, callback, 'POST', data , false)
	  }
	  
	  downloadBrand(callback) {
		this.backend.callBackend(`${Endpoints.brand.private}/catalog/downloadBrand`, callback, "GET")
	  }

	  filterCurrecy(id,callback){
		this.backend.callBackend(`${Endpoints.brand.region}/${id}`,callback);
	}
}